import { setStorage } from "./storage";

/**
 * Stores authentication tokens and user data
 * @param {string} accessToken - JWT access token
 * @param {string} refreshToken - JWT refresh token (optional)
 * @param {Object} user - User data object
 */
export const storeAuthTokens = (accessToken, refreshToken, user) => {
  if (accessToken) {
    setStorage("access_token", accessToken);
  }
  if (user) {
    setStorage("user_session", { userDetails: user });
  }
};

/**
 * Extracts auth data from API response
 * @param {Object} response - API response object
 * @returns {Object|null} Auth data object or null
 */
export const extractAuthData = (response) => {
  const access = response?.results?.access;
  const refresh = response?.results?.refresh;
  const user = response?.results?.user;

  if (access && user) {
    return { access, refresh, user };
  }
  return null;
};

/**
 * Handles successful authentication response
 * @param {Object} response - API response object
 * @param {Function} navigate - Navigation function
 * @param {string} successPath - Path to navigate on success
 * @param {Function} onVerificationNeeded - Callback when verification is needed
 * @returns {boolean} True if auth was successful
 */
export const handleAuthResponse = (response, navigate, successPath = "/home", onVerificationNeeded = null) => {
  if (!response?.success) {
    return false;
  }

  const authData = extractAuthData(response);

  if (authData) {
    storeAuthTokens(authData.access, authData.refresh, authData.user);
    navigate(successPath);
    return true;
  }

  // Check if verification is needed
  if (response?.results?.needs_verification || response?.results?.id) {
    if (onVerificationNeeded) {
      onVerificationNeeded(response);
    }
    return false;
  }

  return false;
};

